import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function recipeSlider() {

  const sections = document.querySelectorAll('.featured-collection.is_swiper');

  if ( !sections.length ) return;
  sections.forEach(section => {
    const container = section.querySelector('.featured-collection-swiper');
    const nextEl = section.querySelector('.swiper-button-next');
    const prevEl = section.querySelector('.swiper-button-prev');
    const paginationEl = section.querySelector('.swiper-pagination');
    const swiper = new Swiper(container, {
      modules: [Navigation, Pagination],
      loop: false,
      slidesPerView: 2,
      spaceBetween: 20,
      pagination:{
        el: paginationEl,
        clickable:true
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      on: {
        init: () => {
        }
      },
      breakpoints: {
        778: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        }
      }
    });


  })
}
